<div class="promptuary-filter">
	<p>{{ 'CONTACT.FILTERS.LABEL' | translate }}</p>
	<freud-button
		(click)="changeSelectedOption('by_all')"
		id="filter__by_all"
		[color]="selected === 'by_all' ? 'primary' : 'secondary'"
		>{{ 'CONTACT.FILTERS.BY_ALL' | translate }}</freud-button
	>
	<freud-button
		(click)="changeSelectedOption('by_me')"
		[color]="selected === 'by_me' ? 'primary' : 'secondary'"
		id="filter__by_me"
		>{{ 'CONTACT.FILTERS.BY_ME' | translate }}</freud-button
	>
	<freud-button
		(click)="changeSelectedOption('by_others')"
		[color]="selected === 'by_others' ? 'primary' : 'secondary'"
		id="filter__by_others"
		>{{ 'CONTACT.FILTERS.BY_OTHERS' | translate }}</freud-button
	>
	<span *ngIf="selected" class="clear_filter" (click)="changeSelectedOption(null)">{{
		'CONTACT.FILTERS.CLEAR' | translate
	}}</span>
</div>
